import React, { useState } from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs";
import { Link } from "react-router-dom";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";
import RecordPopup from "../RecordPopup/RecordPopup.js";

import doctorsData from "../../Data/specialists/specialistsData.json";
import receptionSchedule from "../../Data/specialists/receptionSchedule.json";

export default function Reception() {
  useSEO(seoConfig.reception);

  const [selectedSchedule, setSelectedSchedule] = useState(null);

  const [hoveredDoctor, setHoveredDoctor] = useState(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  // 🔥 состояние попапа записи
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [showRecordPopup, setShowRecordPopup] = useState(false);

  const headers = [
    "Врач",
    "Кабинет",
    "Понедельник",
    "Вторник",
    "Среда",
    "Четверг",
    "Пятница",
  ];

  const doctorsMap = doctorsData.reduce((acc, doctor) => {
    acc[doctor.slug] = doctor;
    return acc;
  }, {});

  const handleMouseMove = (e) => {
    setMousePosition({
      x: e.clientX + 20,
      y: e.clientY - 20,
    });
  };

  // 🔥 открытие попапа

  const handleOpenRecord = (doctor, schedule) => {
    setSelectedDoctor(doctor);
    setSelectedSchedule(schedule);
    setShowRecordPopup(true);
  };

  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Прием специалистов
      </h1>

      <table className="contacts__table first_table">
        {receptionSchedule.map((section, sectionIndex) => (
          <tbody key={sectionIndex}>
            <tr>
              <th className="contacts__caption" colSpan={7}>
                {section.section}
              </th>
            </tr>

            <tr className="contacts__line">
              {headers.map((header, i) => (
                <td key={i} className="contacts__cell second_cell">
                  {header}
                </td>
              ))}
            </tr>

            {section.doctors.map((item, index) => {
              const doctor = doctorsMap[item.slug];

              if (!doctor) return null;

              return (
                <tr className="contacts__line" key={index}>
                  <td className="contacts__cell second_cell">
                    <span
                      onMouseEnter={() => setHoveredDoctor(doctor)}
                      onMouseLeave={() => setHoveredDoctor(null)}
                      onMouseMove={handleMouseMove}
                    >
                      <Link
                        className="reception__contacts_link"
                        to={doctor.link}
                      >
                        {doctor.name}
                      </Link>
                    </span>

                    <br />
                    {doctor.degree || doctor.category || null}
                    <br />

                    <button
                      type="button"
                      className="reseption__record"
                      onClick={() => handleOpenRecord(doctor, item)}
                    >
                      Записаться на прием
                    </button>
                  </td>

                  <td className="contacts__cell second_cell text-align-center">
                    {item.cabinet}
                  </td>

                  {item.work.map((day, i) => (
                    <td key={i} className="contacts__cell second_cell">
                      {day}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        ))}
      </table>

      {/* hover карточка врача */}
      {hoveredDoctor && (
        <div
          className="doctor-floating-preview"
          style={{
            left: mousePosition.x,
            top: mousePosition.y,
          }}
        >
          <img src={hoveredDoctor.photo} alt={hoveredDoctor.name} />
          <div className="doctor-floating-info">
            <h4>{hoveredDoctor.name}</h4>
            <p>{hoveredDoctor.position}</p>
          </div>
        </div>
      )}

      {/* POPUP записи */}
      <RecordPopup
        doctor={selectedDoctor}
        schedule={selectedSchedule}
        show={showRecordPopup}
        onClose={() => setShowRecordPopup(false)}
      />
    </section>
  );
}
